module.exports = new __parcel__URL__("landscape.072df673.png").toString();